var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "delivery-tab-layout",
    {
      staticClass: "delivery-pickup-tab",
      attrs: { loading: _vm.isPointsLoading },
      scopedSlots: _vm._u([
        {
          key: "aside",
          fn: function() {
            return [
              _c(
                "vue-client-only",
                [
                  _vm.adaptive.isDesktop
                    ? _c("d-pickup-filters", {
                        staticClass: "delivery-pickup-tab__filters",
                        model: {
                          value: _vm.filters,
                          callback: function($$v) {
                            _vm.filters = $$v
                          },
                          expression: "filters"
                        }
                      })
                    : _vm._e(),
                  _vm.viewType === _vm.viewTypes.map.value ||
                  _vm.adaptive.isDesktop
                    ? _c("stores-map", {
                        staticClass: "delivery-pickup-tab__map",
                        attrs: {
                          "current-local-city": _vm.currentCity,
                          "active-store-id": _vm.activePointId,
                          stores: _vm.filteredPoints
                        },
                        on: { select: _vm.changeActivePoint }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "append",
          fn: function() {
            return [
              _c("pickup-store-card", {
                attrs: {
                  store: _vm.activePoint,
                  products: _vm.products,
                  ids: _vm.lineIds,
                  distance: _vm.calcDistanceToUser(_vm.activePoint.geo)
                },
                on: {
                  back: _vm.changeActivePoint,
                  select: _vm.onSelectStore,
                  close: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._t("default"),
      _c(
        "vue-client-only",
        [
          !_vm.adaptive.isDesktop
            ? _c("m-pickup-filters", {
                staticClass: "delivery-pickup-tab__filters",
                model: {
                  value: _vm.filters,
                  callback: function($$v) {
                    _vm.filters = $$v
                  },
                  expression: "filters"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "h2",
        { staticClass: "delivery-pickup-tab__subtitle" },
        [
          _c("span", [_vm._v(_vm._s(_vm.pointsCountText) + " самовывоза")]),
          _c(
            "vue-client-only",
            [
              !_vm.adaptive.isDesktop
                ? _c("ui-segmented", {
                    attrs: { labels: Object.values(_vm.viewTypes) },
                    model: {
                      value: _vm.viewType,
                      callback: function($$v) {
                        _vm.viewType = $$v
                      },
                      expression: "viewType"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("vue-client-only", [
        _vm.viewType === _vm.viewTypes.list.value || _vm.adaptive.isDesktop
          ? _c(
              "div",
              { ref: "pickup-list", staticClass: "delivery-pickup-tab__list" },
              [
                _vm.filteredPoints.length
                  ? [
                      _vm._l(
                        _vm.filteredPoints.slice(0, _vm.pointsLimit),
                        function(point) {
                          return _c("pickup-list-item", {
                            key: point.id,
                            staticClass: "delivery-pickup-tab__item",
                            attrs: {
                              store: point,
                              ids: _vm.lineIds,
                              distance: _vm.calcDistanceToUser(point.geo)
                            },
                            on: {
                              select: function($event) {
                                return _vm.changeActivePoint(point.id)
                              }
                            }
                          })
                        }
                      ),
                      _c("span", {
                        directives: [
                          {
                            name: "reached",
                            rawName: "v-reached",
                            value: _vm.increaseLimit,
                            expression: "increaseLimit"
                          }
                        ],
                        staticClass: "delivery-pickup-tab__reached"
                      })
                    ]
                  : _c(
                      "page-info",
                      {
                        staticClass: "delivery-pickup-tab__stub",
                        attrs: {
                          title: "По вашему запросу ничего не&nbsp;найдено"
                        }
                      },
                      [
                        _vm._v(
                          "\n        Попробуйте изменить условия поиска или выберите магазин\n        "
                        ),
                        _c("span", { on: { click: _vm.resetFilters } }, [
                          _vm._v("из списка")
                        ])
                      ]
                    )
              ],
              2
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }